import { render, staticRenderFns } from "./SelectRadio.vue?vue&type=template&id=1b387f08&scoped=true"
import script from "./SelectRadio.vue?vue&type=script&lang=js"
export * from "./SelectRadio.vue?vue&type=script&lang=js"
import style0 from "./SelectRadio.vue?vue&type=style&index=0&id=1b387f08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b387f08",
  null
  
)

export default component.exports